import React, { useEffect, useRef, useState } from 'react';
import styles from './ShimmerLoader.module.css';
import { getIsDarkMode } from '@/store/slices/webConfig';
import { useSelector } from 'react-redux';

export type shimmerProps = {
  count?: number
  containerClass?:string
  boxClass?: string
  parentHeight?: number
}

const ShimmerLoader = ({ count, containerClass, boxClass, parentHeight }: shimmerProps) => {
  const isDarkMode = useSelector(getIsDarkMode);

  const [dynamicCount, setDynamicCount] = useState<number>(count || 0);

  useEffect(() => {
    if (parentHeight) {
      const containerHeight = parseFloat(parentHeight)
      const boxHeight = parseFloat(boxClass.match(/h-\[([^\]]+)\]/)?.[1] || '50') + 12;
      const newCount = Math.floor(containerHeight / boxHeight);
      setDynamicCount(newCount);
    }
  }, [parentHeight]);

  return (
    <div className={`flex flex-col gap-3 bg-white dark:bg-gray-900 overflow-hidden ${containerClass}`}> 
      {Array.from({ length: dynamicCount }).map((_, index) => (
        <div key={index} className={`w-full bg-[#f6f7f8] dark:bg-gray-800 dard:gray-gradient rounded bg-no-repeat ${boxClass} ${styles.shimmerBox} ${isDarkMode ? styles.darkModeGradient : styles.lightModeGradient}`}></div>
      ))}
    </div>
  );
};

export default ShimmerLoader;